import { cn } from "@/lib/utils"

// Shared pill styling for every source's filter strip (Doujins, HentaiEra,
// LewdVault, Civitai, Erome). These strips each carried their own copy of this
// class string, which is how they drifted apart in the first place — and why a
// layout fix had to be applied five times to land.
//
// The drift was visible, not just structural: Erome painted its active pill a
// hardcoded blue (#2563eb, via inline style) and Civitai a purple-600 with a
// glow shadow and a different corner radius, while the rest used the theme's
// primary. Every strip is the same control doing the same job, so they all use
// the theme accent now — one active colour across the bar, and it follows the
// theme instead of being frozen at a hex value.
//
// Note what is deliberately NOT here: `overflow-x-auto`. Each strip used to
// set its own, nested inside SourceFilterBar's scroll container, so an
// overflowing row rendered TWO stacked horizontal scrollbars. The bar owns
// scrolling; the strips just lay out their pills.
//
// Padding steps down on narrow viewports so more pills fit before scrolling
// is needed at all — Doujins has seven, which is where the overflow first
// became obvious on a phone-width layout.
export const SOURCE_FILTER_ROW = "flex items-center gap-1 sm:gap-1.5"

const INACTIVE =
  "bg-secondary/50 text-foreground/70 border-transparent hover:bg-secondary/80 hover:text-foreground"

export function sourceFilterPill(isActive: boolean) {
  return cn(
    "shrink-0 rounded-full px-2 sm:px-2.5 py-1 text-[11px] font-medium transition-colors border",
    isActive ? "bg-primary text-primary-foreground border-primary" : INACTIVE,
  )
}
